import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const steps = [
  { title: "Откройте Avito", desc: "Перейдите на avito.ru в браузере. Авторизация не нужна." },
  { title: "Настройте поиск", desc: "Введите запрос в поисковую строку, выберите город, категорию и нужные фильтры — цену, состояние и т.д." },
  { title: "Скопируйте ссылку", desc: "После настройки всех фильтров скопируйте ссылку из адресной строки — она должна содержать все параметры вашего поиска." },
  { title: "Вставьте в Мини-приложение", desc: "Вернитесь в Авигатор и вставьте скопированную ссылку в поле «Ссылка на Avito» при добавлении поиска." },
];

export const HowToFindLink: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div style={styles.container}>
      <button style={styles.backBtn} onClick={() => navigate("/info")}>
        <ArrowLeft size={16} /> Информация
      </button>
      <h1 style={styles.title}>Как найти ссылку?</h1>
      <p style={styles.lead}>
        Для мониторинга нужна ссылка на страницу поиска Avito — не на конкретное объявление, а на результаты фильтрации.
      </p>
      <div style={styles.steps}>
        {steps.map((step, i) => (
          <div key={i} style={styles.step}>
            <div style={styles.stepNumber}>{i + 1}</div>
            <div>
              <div style={styles.stepTitle}>{step.title}</div>
              <div style={styles.stepDesc}>{step.desc}</div>
            </div>
          </div>
        ))}
      </div>
      <div style={styles.warning}>
        ⚠️ Убедитесь, что ссылка ведёт именно на список объявлений, а не на карточку одного товара.
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: { padding: "16px", maxWidth: "480px", margin: "0 auto" },
  backBtn: { display: "flex", alignItems: "center", gap: "6px", background: "none", border: "none", color: "var(--tg-theme-link-color, #2481cc)", fontSize: "14px", cursor: "pointer", padding: 0, marginBottom: "12px" },
  title: { fontSize: "20px", fontWeight: 700, margin: "0 0 10px 0", color: "var(--tg-theme-text-color, #000)" },
  lead: { fontSize: "14px", color: "var(--tg-theme-hint-color, #666)", marginBottom: "16px", lineHeight: 1.5 },
  steps: { display: "flex", flexDirection: "column", gap: "12px" },
  step: { display: "flex", gap: "12px", padding: "12px", backgroundColor: "var(--tg-theme-secondary-bg-color, #fff)", borderRadius: "12px" },
  stepNumber: { width: "24px", height: "24px", borderRadius: "50%", backgroundColor: "var(--tg-theme-button-color, #2481cc)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "13px", fontWeight: 700, flexShrink: 0 },
  stepTitle: { fontSize: "14px", fontWeight: 600, color: "var(--tg-theme-text-color, #000)", marginBottom: "4px" },
  stepDesc: { fontSize: "13px", color: "var(--tg-theme-hint-color, #666)", lineHeight: 1.4 },
  warning: { marginTop: "16px", padding: "12px", backgroundColor: "#fef3c7", color: "#92400e", borderRadius: "10px", fontSize: "13px", lineHeight: 1.4 },
};
